export default __webpack_public_path__ + "static/media/banner-1.0c6c8659.png";